import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { GridModule } from '@progress/kendo-angular-grid';
import {NavigationComponent} from "./navigation/navigation.component";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {FileService} from "./services/file.service";
import { MatCardModule } from '@angular/material/card';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatListModule} from '@angular/material/list';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';



import { MatFormFieldModule, MatSelectModule ,  MatInputModule} from '@angular/material';

import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { IconsModule } from '@progress/kendo-angular-icons';

import {ScrollingModule} from '@angular/cdk/scrolling';

import {ClipboardModule} from '@angular/cdk/clipboard';

import {AppConsts} from "./appConsts";

import {environment} from "../environments/environment";



import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';

import {Configuration} from 'msal';
import { MainListComponent } from './main-list/main-list.component';
import {RootRoutingModule} from "./app-routing.module";
import {
  HTTP_INTERCEPTORS,
  HttpClientModule
} from "@angular/common/http";
import { FileManagerShellComponent } from './file-manager-shell/file-manager-shell.component';
import {ShellComponent} from "./shell/shell.component";
import {PlatformLocation} from "@angular/common";
import {LoginComponent} from "./login/login.component";
import { TkeLoaderComponent } from './tke-loader/tke-loader.component';
import {PdfJsViewerModule} from "ng2-pdfjs-viewer";


export function MSALInstanceFactory(): any {
  return new PublicClientApplication({
    auth: {
      authority: AppConsts.AD_CONFIG.authority,
      clientId: AppConsts.AD_CONFIG.clientId,
      redirectUri: AppConsts.AD_CONFIG.redirectUrl,
      postLogoutRedirectUri: AppConsts.AD_CONFIG.redirectUrl,
      navigateToLoginRequestUrl:true
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false // set to true for IE 11
    }
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(AppConsts.AD_CONFIG.protectedResources[0][0], AppConsts.AD_CONFIG.protectedResources[0][1]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { interactionType: InteractionType.Redirect };
}

@NgModule({
  declarations: [
    LoginComponent,
    AppComponent,
    NavigationComponent,
    MainListComponent,
    ShellComponent,
    FileManagerShellComponent,
    TkeLoaderComponent
  ],
  imports: [
    MatTooltipModule,
    PdfJsViewerModule,
    ClipboardModule,
    MatListModule,
    MatMenuModule,
    MatButtonModule,
    MatInputModule,
    MatButtonToggleModule,
    RootRoutingModule,
    IndicatorsModule,
    IconsModule,
    BrowserModule,
    LayoutModule,
    NavigationModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    MatBottomSheetModule,
    MatCardModule,
    MatIconModule,
    InputsModule,
    MsalModule,
    MatFormFieldModule,
    MatSelectModule,
    DropDownsModule,
    GridModule,
    ScrollingModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    FileService,
    {provide: APP_INITIALIZER, useFactory: (platformLocation) => {
      return () => {
        return Promise.resolve().then(() => {
          AppConsts.appBaseHref = getBaseHref(platformLocation);
          const appBaseUrl = getDocumentOrigin() + AppConsts.appBaseHref;
          return fetch(appBaseUrl + 'assets/' + environment.appConfig).then((response) => {
            return response.json();
          })
            .then((response) => {
              AppConsts.remoteServiceBaseUrl = response.remoteServiceBaseUrl;
              AppConsts.AD_CONFIG = response.AD_CONFIG;
              AppConsts.appBaseUrl = response.appBaseUrl;
              AppConsts.ALLOWED_DOMAINS = response.allowedDomains;
              AppConsts.JobFilesDataSource = response.JobFilesDataSource;
              AppConsts.GuidedownloadUrl= response.GuidedownloadUrl;
              return Promise.resolve();
            });
        })
      }
      }, deps: [PlatformLocation], multi: true}
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }



export function getBaseHref(platformLocation: PlatformLocation): string {
  const baseUrl = platformLocation.getBaseHrefFromDOM();
  if (baseUrl) {
    return baseUrl;
  }

  return '/';
}

function getDocumentOrigin() {
  if (!document.location.origin) {
    const port = document.location.port ? ':' + document.location.port : '';
    return document.location.protocol + '//' + document.location.hostname + port;
  }

  return document.location.origin;
}
